import React from "react";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { ErrorCircleRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  errorButton: {
    position: "fixed",
    top: "50%",
    right: "16px",
    transform: "translateY(-50%)",
    zIndex: 1001,
    backgroundColor: tokens.colorPaletteRedBackground3,
    borderTopColor: tokens.colorPaletteRedBorder1,
    borderRightColor: tokens.colorPaletteRedBorder1,
    borderBottomColor: tokens.colorPaletteRedBorder1,
    borderLeftColor: tokens.colorPaletteRedBorder1,
    color: tokens.colorNeutralForegroundOnBrand,
    ":hover": {
      backgroundColor: tokens.colorPaletteRedBackground2,
      borderTopColor: tokens.colorPaletteRedBorder2,
      borderRightColor: tokens.colorPaletteRedBorder2,
      borderBottomColor: tokens.colorPaletteRedBorder2,
      borderLeftColor: tokens.colorPaletteRedBorder2,
    },
    ":active": {
      backgroundColor: tokens.colorPaletteRedBackground1,
      borderTopColor: tokens.colorPaletteRedBorder2,
      borderRightColor: tokens.colorPaletteRedBorder2,
      borderBottomColor: tokens.colorPaletteRedBorder2,
      borderLeftColor: tokens.colorPaletteRedBorder2,
    },
  },
});

interface FloatingErrorButtonProps {
  errorCount: number;
  onClick: () => void;
  warningCount?: number;
}

const FloatingErrorButton: React.FC<FloatingErrorButtonProps> = ({
  errorCount,
  onClick,
  warningCount = 0,
}) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const totalCount = errorCount + warningCount;

  if (totalCount === 0) {
    return null;
  }

  const getErrorText = () => {
    if (warningCount > 0 && errorCount > 0) {
      return t("qtg.validation.errorsAndWarnings", {
        errorCount,
        warningCount,
      });
    } else if (errorCount > 0) {
      return `${errorCount} ${
        errorCount === 1
          ? t("qtg.validation.error")
          : t("qtg.validation.errors")
      }`;
    } else {
      return `${warningCount} ${
        warningCount === 1
          ? t("qtg.validation.warning")
          : t("qtg.validation.warnings")
      }`;
    }
  };

  return (
    <Button
      appearance="primary"
      icon={<ErrorCircleRegular />}
      className={styles.errorButton}
      onClick={onClick}
      size="large"
    >
      {getErrorText()}
    </Button>
  );
};

export default FloatingErrorButton;
